import { toQuery, type HttpClient } from '../client';
import type {
  AnalyticsQuery,
  CategoryMetricRow,
  GovInstQuery,
  GovInstRow,
  GovSummaryRow,
  MaterialMetricRow,
  OrgMetricRow,
  OverviewRow
} from '../types/analytics';

/** 驾驶舱/监管统计（跨机构需 level=admin）。 */
export function createAnalyticsApi(http: HttpClient) {
  return {
    overview(query: AnalyticsQuery = {}): Promise<OverviewRow> {
      return http.request<OverviewRow>({ path: '/wl/analytics/overview', query: toQuery(query) });
    },
    orgs(query: AnalyticsQuery = {}): Promise<OrgMetricRow[]> {
      return http.request<OrgMetricRow[]>({ path: '/wl/analytics/orgs', query: toQuery(query) });
    },
    categories(query: AnalyticsQuery = {}): Promise<CategoryMetricRow[]> {
      return http.request<CategoryMetricRow[]>({ path: '/wl/analytics/categories', query: toQuery(query) });
    },
    materials(query: AnalyticsQuery = {}): Promise<MaterialMetricRow[]> {
      return http.request<MaterialMetricRow[]>({ path: '/wl/analytics/materials', query: toQuery(query) });
    },
    /** 驾驶舱机构排行（读 gov_inst_metric 快照，含同比/环比/排名变化）。 */
    govInst(query: GovInstQuery = {}): Promise<GovInstRow[]> {
      return http.request<GovInstRow[]>({ path: '/wl/analytics/gov/inst', query: toQuery(query) });
    },
    /** 全区监管汇总（采购总额、同比、环比、异常闭环率等）。 */
    govSummary(query: GovInstQuery = {}): Promise<GovSummaryRow> {
      return http.request<GovSummaryRow>({ path: '/wl/analytics/gov/summary', query: toQuery(query) });
    }
  };
}

export type AnalyticsApi = ReturnType<typeof createAnalyticsApi>;
